import { PRODUCT_DETAILED_CART_DATA } from '../products/queries';

export const CART_QUERY_FRAGMENT =
  `
  fragment CartFragment on Cart {
    cost {
        subtotalAmount {
            amount
            currencyCode
        }
        totalAmount {
            amount
            currencyCode
        }
        totalDutyAmount {
            amount
            currencyCode
        }
    }
    discountCodes {
        applicable
        code
    }
    discountAllocations {
        discountedAmount {
            amount
            currencyCode
        }
    }
    id
    note
    checkoutUrl
    lines(first: $numCartLines) {
      edges {
            node {
                cost {
                    compareAtAmountPerQuantity {
                        amount
                        currencyCode
                    }
                    totalAmount {
                        amount
                        currencyCode
                    }
                }
                merchandise {
                    ... on ProductVariant {
                        availableForSale
                        compareAtPrice {
                            amount
                            currencyCode
                        }
                        id
                        sku
                        image {
                            url
                        }
                        price {
                            amount
                            currencyCode
                        }
                        requiresShipping
                        selectedOptions {
                            name
                            value
                        }
                        title
                        quantityAvailable
                        product {
                             ` +
  PRODUCT_DETAILED_CART_DATA +
  `
                        }
                    }
                }
                id
                quantity
                sellingPlanAllocation {
                    sellingPlan {
                        name
                    }
                }
            }
        }
    }
  }
`;

export const CART_DATA =
  `
cart {
    cost {
        subtotalAmount {
            amount
            currencyCode
        }
        totalAmount {
            amount
            currencyCode
        }
        totalDutyAmount {
            amount
            currencyCode
        }
    }
    discountCodes {
        applicable
        code
    }
    discountAllocations {
        discountedAmount {
            amount
            currencyCode
        }
    }
    id
    lines(first: 250) {
        edges {
            node {
                cost {
                    compareAtAmountPerQuantity {
                        amount
                        currencyCode
                    }
                    totalAmount {
                        amount
                        currencyCode
                    }
                }
                merchandise {
                    ... on ProductVariant {
                        availableForSale
                        compareAtPrice {
                            amount
                            currencyCode
                        }
                        id
                        image {
                            url
                        }
                        price {
                            amount
                            currencyCode
                        }
                        requiresShipping
                        selectedOptions {
                            name
                            value
                        }
                        title
                        quantityAvailable
                        product {
                            ` +
  PRODUCT_DETAILED_CART_DATA +
  `
                        }
                    }
                }
                id
                quantity
                sellingPlanAllocation {
                    sellingPlan {
                        name
                    }
                }
            }
        }
    }
}`;

export const UPDATE_CART_ITEMS =
  `
mutation updateCartItems(
    #$lines: [CartLineUpdateInput!]!, 
    $cartId: ID!, 
    $lineItems: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lineItems) {
        ` +
  CART_DATA +
  `
        userErrors {
          field
          message
        }
    }
}`;

export const ADD_CART_ITEMS =
  `
mutation addCartItems(
    $cartId: ID!, 
    $lineItems: [CartLineInput!]!) {
        cartLinesAdd(cartId: $cartId, lines: $lineItems) {
            ` +
  CART_DATA +
  `
            userErrors {
              field
              message
        }
    }
}`;

export const REMOVE_CART_ITEMS =
  `
mutation removeCartItems(
    $cartId: ID!, 
    $lineIds: [ID!]!) {
        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
        ` +
  CART_DATA +
  `
        userErrors {
            field
            message
        }
    }
}`;

export const CART_ATTRIBUTES_UPDATE =
  `
mutation cartAttributesUpdate(
    $cartId: ID!, 
    $attributes: [AttributeInput!]!) {
        cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
            ` +
  CART_DATA +
  `
            userErrors {
              field
              message
        }
    }
}`;

export const CART_CREATE =
  `
mutation createCart($input: CartInput!) {
  cartCreate(input: $input) {
    ` +
  CART_DATA +
  `
    userErrors {
      field
      message
    }
  }
}
`;
